import { SUPPORTED } from '@/i18n';
import { localizedPath } from './useLocalizedRoute';
const SITE_NAME = 'Travelling Dominika';
const ORIGIN = 'https://www.travellingdominika.com';
const HREFLANG_DATA_ATTR = 'data-td-hreflang';
const setMeta = (selector, content) => {
    if (typeof document === 'undefined')
        return;
    let el = document.head.querySelector(selector);
    if (!content)
        return;
    if (!el) {
        el = document.createElement('meta');
        const [, attr, value] = selector.match(/\[([^=]+)="([^"]+)"\]/) || [];
        if (attr && value)
            el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
};
const setLink = (rel, href) => {
    if (typeof document === 'undefined' || !href)
        return;
    let el = document.head.querySelector(`link[rel="${rel}"]:not([${HREFLANG_DATA_ATTR}])`);
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
};
const setHreflangs = (basePath) => {
    if (typeof document === 'undefined')
        return;
    // Clear previously injected hreflang tags.
    document.head.querySelectorAll(`link[${HREFLANG_DATA_ATTR}]`).forEach((n) => n.remove());
    const make = (hreflang, href) => {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', hreflang);
        link.setAttribute('href', href);
        link.setAttribute(HREFLANG_DATA_ATTR, '');
        document.head.appendChild(link);
    };
    SUPPORTED.forEach((loc) => {
        make(loc, `${ORIGIN}${localizedPath(basePath, loc)}`);
    });
    // x-default falls back to English (canonical).
    make('x-default', `${ORIGIN}${basePath}`);
};
export const setHead = (config) => {
    if (typeof document === 'undefined')
        return;
    const fullTitle = config.title.includes(SITE_NAME)
        ? config.title
        : `${config.title} · ${SITE_NAME}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', config.description);
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[property="og:description"]', config.description);
    setMeta('meta[property="og:image"]', config.ogImage);
    setMeta('meta[name="twitter:title"]', fullTitle);
    setMeta('meta[name="twitter:description"]', config.description);
    setMeta('meta[name="twitter:image"]', config.ogImage);
    if (config.basePath !== undefined) {
        const localizedHref = `${ORIGIN}${localizedPath(config.basePath)}`;
        setLink('canonical', localizedHref);
        setMeta('meta[property="og:url"]', localizedHref);
        setHreflangs(config.basePath);
    }
};
